<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="blue">
        <h4 slot="title" class="title" style="padding: 25px"><strong>Partners Login</strong></h4>
        <template slot="inputs">
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>email</md-icon>
              <label>E-mail Address</label>
              <md-input v-model="email" type="email"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </template>

        <template slot="inputs">
          <ValidationProvider
            name="password"
            rules="required|min:6"
            v-slot="{ passed, failed }"
          >
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <md-icon>lock_outline</md-icon>
              <label>Password</label>
              <md-input v-model="password" type="password"> </md-input>

              <slide-y-down-transition>
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </md-field>
          </ValidationProvider>
        </template>
        <md-button
          @click="login"
          slot="footer"
          class="md-simple md-info md-lg"
        >
          Lets Go
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("min", min);
export default {
  components: {
    LoginCard,
    SlideYDownTransition
  },
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    login() {
      if (this.email == null || this.email === "") {
        this.$notify({
          message: "Email is required.",
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
        return;
      } else if (this.password == null || this.password === "") {
        this.$notify({
          message: "Password is required.",
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
        return;
      } else if (this.email.indexOf("@") === -1) {
        this.$notify({
          message: "Enter a valid email address.",
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
        return;
      } else if (this.password.length < 6) {
        this.$notify({
          message: "Password must be at least 6 characters.",
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
        return;
      }
      this.$store
        .login({
          email: this.email,
          password: this.password
        })
        .then(response => {
          this.$router.push({ name: "Dashboard" });
        })
        .catch(error => {
          if (error.response.data.email) {
            var message = error.response.data.email[0];
          } else {
            var message = error.response.data.detail;
          }

          this.$notify({
            message: message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  }
};
</script>

<style></style>
